/*
 * Project: LegalPlace assistant
 * File: src/redux/reducers/flat_ui.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import {
  F_UI_CREATE,
  F_UI_SET_ACTIVE,
  F_UI_IS_MULTIPLE,
  F_UI_COPY_NUMBER,
  F_UI_RADIO_ACTIVE,
  REMOVE_DUPLICATE,
} from '../actions/flat_ui';


// The control
export default function flatUIReducer(state = [], action) {
  switch (action.type) {
    case REMOVE_DUPLICATE:
      return [];
    case F_UI_CREATE:
      return state.slice();
    case F_UI_SET_ACTIVE:
      return state;
    case F_UI_IS_MULTIPLE:
      return state;
    case F_UI_COPY_NUMBER:
      return state;
    case F_UI_RADIO_ACTIVE:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/flat_ui.js